

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiTemplateService, Core2Config, ApiVisa, ApiResponseModel } from '../shared';

// /core2/tnt/dm/applet/login-subject-links

@Injectable({
  providedIn: 'root'
})
export class TenantAppletSwitchUserService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet/login-subject-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet/login-subject-links';
    this.httpClient = http;
  }
  

  // /core2/tnt/dm/applet/login-subject-links/generate-applet-token/tenant-ep
  getNewAppletTokenTenantEP(dtoObject: any, apiVisa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (apiVisa && apiVisa.api_domain_url != null) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path
    }
    const url = this.apiUrl + '/generate-applet-token/tenant-ep';
    return this.httpClient.post<ApiResponseModel<AnalyserOptions>>(
      url,
      dtoObject,
      this.getHttpHeader(apiVisa)
    );
  }
}

